// extracted by mini-css-extract-plugin
export var measureBox = "_b2-0";